export const BKJThemeLoadingSpinner = {
    Default: {
        width: 60,
        height: 60,
    },
    Small: {
        width: 38,
        height: 38,
    },
    XSmall: {
        width: 20,
        height: 20,
    },
};
//# sourceMappingURL=BKJLoadingSpinner.theme.js.map